<style lang="less" scoped>
@import "./index.less";
</style>

<template>
  <div class="car-plate-binding">
    <div class="img-wrap">
      <img src="../../../../assets/images/image232.png" width="89" height="87" alt="">
      <div>为了给您更好的行车体验，请准确填写相关信息哦～</div>
    </div>
    <div class="step">
      <div class="step-number">
        <div class="point"><span>1</span></div>
        <div class="hr"></div>
        <div class="point active"><span>2</span></div>
        <div class="hr"></div>
        <div class="point"><span>3</span></div>
      </div>
    </div>
    <router-link :to="{name:'carBrand'}" class="plate">
      <div class="title" v-if="!canNext">请选择您的车辆类型</div>
      <div v-else class="item">
          <img :src="carLogo" alt="" srcset="">
          <span>{{ carModel }}</span>
        </div>
    </router-link>
    <div style="text-align: center;"><button :disabled="!canNext"  class="submit" @click="nextStep">下一步</button></div>
  </div>
</template>

<script>
export default {
  name: 'CarText',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    carLogo () {
      return this.$store.state.bindData.car_icon
    },
    canNext () {
      return this.$store.state.bindData.series_id
    },
    carModel () {
      return this.$store.state.bindData.car_brand+'-' + this.$store.state.bindData.car_model
    }
  },

  methods: {
    onSelect(action) {
      this.$toast(action.text);
    },
    nextStep(){
      this.$router.push("recordData");
    }
  }
}
</script>
